import React, {Component} from 'react';
import axios from 'axios'; 
import {   Link } from 'react-router-dom'; 
import {api_base_url, base_url} from '../common/Constants';

class Footer extends Component {

    constructor(){
        super();
        this.state = {
            posts : [],
            name:'Login',
            cart : [],
            loading:1,
            settings:{}
        }
    }
    componentDidMount()
    { 

             
                this.setState({posts:JSON.parse(localStorage.getItem("blogs"))}) ; 
                this.setState({settings:JSON.parse(localStorage.getItem("settings"))}) ; 
               this.setState({loading:0}); 
            
        
       
    }

     
        scrollToTop = () => {
          window.scrollTo({
            top: 0,
            behavior: "smooth", // Smooth scrolling effect
          });
        };
      

    render()
    {
        if (this.state.loading == 1) {
            return <div>Loading...</div>;
          }
 
  return (

       <footer class="ul-footer">
        <div class="ul-inner-container">
        

            <div class="ul-footer-middle">
           
                <div class="ul-footer-middle-widget align-self-center logo-container">
                    <Link to={base_url}><img src={base_url+"assets/img/kloth.jpg"} alt="logo" class="logo" /></Link>
                </div>

                
                <div class="ul-footer-middle-widget">
                    <h3 class="ul-footer-middle-widget-title">Follow us</h3>
                    <div class="ul-footer-middle-widget-content">
                        <div class="social-links">
                            <Link to={this.state.settings.site_facebook_url}  target="_blank"><i className="flaticon-facebook-app-symbol"></i></Link>
                                          <Link to={this.state.settings.site_instagram_url}  target="_blank"><i className="flaticon-instagram"></i></Link>
                                          <Link to={this.state.settings.site_youtube_url} aria-hidden="true" target="_blank"><i className="flaticon-youtube"></i></Link>
                        </div>
                    </div>
                </div>

                
                <div class="ul-footer-middle-widget">
                    <h3 class="ul-footer-middle-widget-title">Need help? Call now!</h3>
                    <div class="ul-footer-middle-widget-content">
                        <div class="contact-nums">
                        <a href={"tel:"+this.state.settings.site_facebook_url} >{this.state.settings.contact_phone_number}</a>
                        </div>
                    </div>
                </div>

              
            </div>

            <div class="ul-footer-bottom">
                <p class="copyright-txt">              ©2025 {this.state.settings.site_title}, Developed By <a href="https://aivatetech.com/">aivatetech.com</a>   </p>
                   <div class="ul-footer-top-widget-links">
                        <Link to={base_url+"terms-of-use"}>Terms of Service</Link>
                        <Link to={base_url+"refund-policy"}>Refund policy</Link>
                    </div>
            </div>
        </div>
    </footer>
         
  
);
}
};

export default Footer;